import axios from 'axios'
import Api from '@/api'

const QrAxios = axios.create({
  baseURL: Api.qr_service_url
})

export default {

  async generateQrZip (options) {
    const defaults = {
      color: '#000000',
      background: '#FFFFFF',
      quiet_zone: 4,
      qr_scale: 2,
      text: {
        color: '#000000',
        scale: 2
      },
      image: null,
      output_format: 'svg',
      ec_level: 'Q'
    }

    const codes = options.codes.map((code) => ({ ...defaults, ...code }))

    return new Promise((resolve, reject) => {
      QrAxios.post('/v2/multi/', { codes }, { responseType: 'blob' }).then((res) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([res.data], { type: res.data.type }))
        const link = document.createElement('a')

        link.href = downloadUrl
        link.setAttribute('download', 'qr-codes.zip')
        document.body.appendChild(link)
        link.click()
        link.remove()
        resolve(res.data)
      }).catch(async (err) => {
        let message = ''
        // try/catch is needed so that we reach reject(new Error(message)) even if error body isn't JSON
        try {
          const errorText = await err.response?.data?.text?.()
          if (errorText) {
            const errorMessage = JSON.parse(errorText)
            const fieldErrors = errorMessage?.errors && Object.values(errorMessage.errors).flat().filter((v) => typeof v === 'string').join(' ')
            message = errorMessage?.details?.message || errorMessage?.message || fieldErrors || err?.message
          }
        } catch {}

        reject(new Error(message))
      })
    })
  }

}
